import { render } from "./EditBuyer.vue?vue&type=template&id=c94b4f86"
import script from "./EditBuyer.vue?vue&type=script&lang=js"
export * from "./EditBuyer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Buyback/EditBuyer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c94b4f86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c94b4f86', __exports__)) {
    api.reload('c94b4f86', __exports__)
  }
  
  module.hot.accept("./EditBuyer.vue?vue&type=template&id=c94b4f86", () => {
    api.rerender('c94b4f86', render)
  })

}


export default __exports__